import { appApi } from '../app_api';

export const groupsApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getGroups: builder.query({
      query: ({ roundId, confirming }) => `/rounds/${roundId}/groups?confirming=${confirming || false}`,
      transformResponse: (response) => Array.isArray(response.groups) ? response.groups : [],
      providesTags: (result, error, { roundId }) => 
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Group', id })),
              { type: 'EventRoundGroups', id: roundId },
            ]
          : [{ type: 'EventRoundGroups', id: roundId }],
    }),
    getGroupLeaderboard: builder.query({
      query: ({groupId }) => `/groups/${groupId}/leaderboard`,
      transformResponse: (response) => response.data || [],
      providesTags: (result, error, { groupId }) => 
        result
          ? [
              { type: 'GroupLeaderboard', id: groupId },
            ]
          : [{ type: 'GroupLeaderboard', id: groupId }],
    }),
    getGroupConflicts: builder.query({
      query: ({groupId }) => `/groups/${groupId}/conflicts`,
      transformResponse: (response) => response.data || [],
      providesTags: (result, error, { groupId }) => 
        result
          ? [
              { type: 'GroupConflicts', id: groupId },
            ]
          : [{ type: 'GroupConflicts', id: groupId }],
    }),
    getCurrentUserScoringPermission: builder.query({
      query: ({ groupId }) => `/groups/${groupId}/current_user_scoring_permission`,
      transformResponse: (response) => response.data,
    }),
    confirmGroupLeaderboard: builder.mutation({
      query: ({ groupId }) => ({
        url: `/groups/${groupId}/confirm_leaderboard`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, { groupId, roundId }) => [
        { type: 'GroupLeaderboard', id: groupId },
        { type: 'GroupConflicts', id: groupId },
        { type: 'Group', id: groupId },
        { type: 'EventGroupsReviewedRound', id: result.roundId },
        { type: 'GroupInstances', id: groupId },
        { type: 'RoundCanContinue', id: roundId },
      ],
    }),
    reorderPlayers: builder.mutation({
      query: ({ groupId, instances }) => ({
        url: `/groups/${groupId}/reorder_players`,
        method: 'PUT',
        body: { instances },
      }),
      invalidatesTags: (result, error, { groupId }) => [
        { type: 'GroupLeaderboard', id: groupId },
        { type: 'GroupConflicts', id: groupId },
        { type: 'GroupInstances', id: groupId },
        { type: 'Group', id: groupId }
      ],
    }),
    assignTables: builder.mutation({
      query: ({ roundId, assignments }) => ({
        url: `/rounds/${roundId}/assign_tables`,
        method: 'PUT',
        body: { assignments },
      }),
      invalidatesTags: (result, error, { groupIds }) =>
        (groupIds || []).flatMap(id => [
          { type: 'Group', id },
          { type: 'GroupMatches', id }
        ]),
    }),
  }),
});

export const {
  useGetGroupsQuery,
  useGetGroupLeaderboardQuery,
  useGetGroupConflictsQuery,
  useGetCurrentUserScoringPermissionQuery,
  useConfirmGroupLeaderboardMutation,
  useReorderPlayersMutation,
  useAssignTablesMutation,
} = groupsApi;